import {
  Box,
  Grid,
  Typography,
  Button,
  Select,
  MenuItem,
  TextField,
  Table,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";
import {
  EditableTextField,
  EditableSelectField,
} from "../../../../Global_Component/CustomInputComponent";

const PrimaryPayment = () => {
  const [rows, setRows] = useState([
    { id: 1, particular: "Halal Product Scheme", products: 1, fee: "1000 INR" },
  ]);

  const options = [
    "Halal Product Scheme",
    "Halal Whole Plant Scheme",
    "Halal Restaurant Scheme",
  ];

  const handleAddRow = () => {
    setRows([
      ...rows,
      { id: rows.length + 1, particular: "", products: 1, fee: "" },
    ]);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  const termsAndConditions = [
    {
      title: "Eligibility",
      content:
        "This receipt is issued only to individuals and entities eligible for tax deduction under Section 80G of the Income Tax Act, 1961.",
    },
    {
      title: "Donation Details",
      content:
        "The receipt acknowledges a voluntary donation made to the Halal India Research Council, a recognized charitable organization.",
    },
    {
      title: "Receipt Validity",
      content:
        "This receipt is valid only if it contains the following details: Name and address of the donor, PAN of the donor, Amount donated (in figures and words), Date of donation, Receipt number, and Signature and seal of the authorized signatory of the Halal India Research Council.",
    },
    {
      title: "Non Refundable",
      content:
        "Donations once made are non-refundable under any circumstances.",
    },
    {
      title: "Tax Deduction",
      content:
        "The donation is eligible for tax deduction under Section 80G of the Income Tax Act, 1961. The extent of deduction available may be subject to changes in tax laws. Donors are advised to consult their tax advisors for specific details.",
    },
    {
      title: "Purpose of Donation",
      content:
        "The donated amount will be used for the charitable activities and projects undertaken by the Halal India Research Council as per its mandate.",
    },
    {
      title: "Duplicate Receipts",
      content:
        "Duplicate receipts can be issued upon request, provided sufficient proof of the original donation is submitted.",
    },
    {
      title: "Changes in Information",
      content:
        "Donors must inform the Halal India Research Council promptly of any changes in their contact information or PAN.",
    },
    {
      title: "Usage of Donor Information",
      content:
        "The Halal India Research Council respects donor privacy and will not disclose any personal information to third parties without prior consent, except as required by law.",
    },
    {
      title: "Governing Law",
      content:
        "This receipt and the terms and conditions herein shall be governed by and construed in accordance with the laws of India. Any disputes arising from this receipt shall be subject to the exclusive jurisdiction of the courts in India.",
    },
  ];

  return (
    <>
      <Box
        sx={{
          maxWidth: "100%",
          margin: "auto",
          padding: "10px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fff",
          height: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
          section 1
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
            height: "auto",
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
          >
            <Grid
              container
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                ></Typography>
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="name"
                  label="Raised by"
                  value="Hala india Research council 919,evr periyar salai 1st lane purasawalka chennai 600084"
                  isEdit={false}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Raised to"
                  value="SAVORY BITES P BLOCK ,anna Nagar ,Chennai,Tamil"
                  options={[]}
                  isEdit={false}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="industry Type"
                  value="Fitness"
                  options={[
                    { label: "finance", valud: "finance" },
                    { label: "Fitness", value: "Fitness" },
                  ]}
                  isEdit={false}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="N0 of Product"
                  value="4"
                  options={[]}
                  isEdit={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <TableContainer component={Paper} className="p-4">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>SL No.</TableCell>
                <TableCell>Particular</TableCell>
                <TableCell>Number of Products</TableCell>
                <TableCell>Service Fee (In INR)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>
                    <Select
                      value={row.particular}
                      onChange={(e) =>
                        handleRowChange(index, "particular", e.target.value)
                      }
                      fullWidth
                    >
                      {options.map((option, idx) => (
                        <MenuItem key={idx} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      value={row.products}
                      onChange={(e) =>
                        handleRowChange(index, "products", e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      value={row.fee}
                      onChange={(e) =>
                        handleRowChange(index, "fee", e.target.value)
                      }
                      fullWidth
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddRow}
            className="mt-4"
            style={{ marginTop: "16px" }}
          >
            Add More Row
          </Button>
        </TableContainer>
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          margin: "auto",
          padding: "10px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fff",
          height: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
          section 2 Tax Information
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
            height: "auto",
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
          >
            <Grid
              container
              sm={5}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                ></Typography>
              </Grid>

              <Grid item md={7} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="Availing 80 G receipt"
                  value="Fitness"
                  options={[
                    { label: "Yes", valud: "yes" },
                    { label: "No", value: "no" },
                  ]}
                  isEdit={false}
                />
              </Grid>

              <Grid item md={7} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Availing 80 G receipt Under pan Card"
                  value="API35125"
                  options={[]}
                  isEdit={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", ml: 1, fontWeight: "500", color: "#333" }}
      >
        Terms and Condition for 80G Receipt
      </Typography>
      <Container fullWidth sx={{ m: 0, p: 0 }}>
        <Box>
          {termsAndConditions.map((item, index) => (
            <Box key={index} mb={3}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "400", m: 0 }}
                gutterBottom
              >
                {index + 1}. {item.title}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "300" }}>
                {item.content}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>

      <Box
        sx={{
          maxWidth: "100%",
          margin: "auto",
          padding: "10px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fff",
          height: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
          section 4 Audit date & Auditor allocation
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
            height: "auto",
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
          >
            <Grid
              container
              sm={7}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                ></Typography>
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="name"
                  label="Date"
                  value="29/07/2024"
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Payment Mode"
                  value="online"
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="usage"
                  label="industry Type"
                  value="Fitness"
                  options={[
                    { label: "finance", valud: "finance" },
                    { label: "Fitness", value: "Fitness" },
                  ]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="plant Address"
                  value="4"
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Country"
                  value="India"
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="State"
                  label="Tamil Nadu"
                  value="4"
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="City"
                  value="chennai"
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Zip Code"
                  value="60040"
                  options={[]}
                  isEdit={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          margin: "auto",
          padding: "10px",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          backgroundColor: "#fff",
          height: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
        >
          section 5 Financer Detail
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
            height: "auto",
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
          >
            <Grid
              container
              sm={7}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                ></Typography>
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="name"
                  label="name"
                  value="akash sign"
                  isEdit={false}
                />
              </Grid>

              <Grid item md={5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="category"
                  label="Designation"
                  value="Finance Manager"
                  options={[]}
                  isEdit={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>



        <Grid container spacing={0} sx={{display:"flex",justifyContent:"end",gap:1}}>
          <CustomSecondaryButton label={"Back"}/>
          <CustomSuccessButton label={"Generate Receipt"}/>
        </Grid>
      </Box>
    </>
  );
};

export default PrimaryPayment;
